import { render, staticRenderFns } from "./SelectStrategyImportFromIDML.vue?vue&type=template&id=1a1fd5b2"
import script from "./SelectStrategyImportFromIDML.vue?vue&type=script&lang=js"
export * from "./SelectStrategyImportFromIDML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1fd5b2')) {
      api.createRecord('1a1fd5b2', component.options)
    } else {
      api.reload('1a1fd5b2', component.options)
    }
    module.hot.accept("./SelectStrategyImportFromIDML.vue?vue&type=template&id=1a1fd5b2", function () {
      api.rerender('1a1fd5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/SelectStrategyImportFromIDML.vue"
export default component.exports